import { createSlice } from "@reduxjs/toolkit";

export const bookingSlice = createSlice({
    name: "booking",
    initialState: {
      bookings: [], 
      loading: false,
      error: null,
    },
    reducers: {
        setLoading: (state) => {
          state.loading = true;
          state.error = null; 
        },
        setBookings: (state, action) => {
          state.loading = false;
          state.error = null;
          state.bookings = action.payload.data; 
      },
        setError: (state, action) => {
          state.loading = false;
          state.error = action.payload;
        }, 
      },
})

export const {
    setLoading,
    setBookings,
    setError,
  } = bookingSlice.actions;
  
  export default bookingSlice.reducer;

